





















import { Specification } from '~/models/classified/types'
import { mapGetters, mapState } from 'vuex'
import DamagedBadge from '~/components/car/classifieds/badges/DamagedBadge.vue'
import WithoutVatBadge from '~/components/car/classifieds/badges/WithoutVatBadge.vue'
import ForeignNumbersBadge from '~/components/car/classifieds/badges/ForeignNumbersBadge.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CBadge,
    DamagedBadge,
    WithoutVatBadge,
    ForeignNumbersBadge
  },
  props: {
    specification: {
      type: Object as PropType<Specification>,
      required: true
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      conditionType: state => state.classified.condition_type
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isDamaged: 'isDamaged',
      externalLink: 'externalLink',
      hasLeasing: 'hasLeasing'
    })
  }
})
